import { Observable } from 'rxjs';
import { PersonalShopperPublicModel } from '../models/personalShopper.model';


export abstract class PersonalShopperPublicRepository {
    abstract getAll(): Observable<PersonalShopperPublicModel[]>;
}
